import React from 'react';
import {List } from 'antd';
import { Link } from "react-router-dom";
import Reports from './reports.component';

const ReportsContainer = () => {
    return (
        <Reports />
    );
}

export default ReportsContainer;


// WEBPACK FOOTER //
// ./src/pages/reports/index.js